import { render, staticRenderFns } from "./interest.vue?vue&type=template&id=63181913&"
import script from "./interest.vue?vue&type=script&lang=js&"
export * from "./interest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports